import { StateService } from "../services/state.service";

export abstract class BaseState {
    constructor(protected stateService: StateService) { }
    protected get store() { return this.stateService.store; }
    protected get snapshot() { return this.stateService.snapshot; }
}